import React from "react";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";

import { Menu, MenuItem, Popover } from "@blueprintjs/core";

const Actions = (props) => {
  const optionsMenu = (
    <Menu>
      <MenuItem
        onClick={() =>
          props.onEditClicked ? props.onEditClicked() : undefined
        }
        text="Edit"
      />
      <MenuItem text="Delete" />
    </Menu>
  );
  return (
    <div>
      <div className="more-details-ellipsis-container">
        <Popover content={optionsMenu} position="bottom">
          <DotsHorizontalIcon />
        </Popover>
      </div>
    </div>
  );
};

export default Actions;
